var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6348 32.7733V29.7156C21.6348 28.9351 22.2722 28.3023 23.0584 28.3023H25.9326C26.3102 28.3023 26.6723 28.4512 26.9393 28.7163C27.2063 28.9813 27.3563 29.3408 27.3563 29.7156V32.7733C27.3539 33.0978 27.4821 33.4099 27.7124 33.6402C27.9427 33.8705 28.2561 34 28.5829 34H30.5438C31.4596 34.0023 32.3388 33.6428 32.9872 33.0008C33.6356 32.3588 34 31.487 34 30.5778V21.8669C34 21.1325 33.6721 20.4358 33.1046 19.9647L26.434 14.6759C25.2737 13.7486 23.6111 13.7785 22.4854 14.747L15.967 19.9647C15.3727 20.422 15.0176 21.1206 15 21.8669V30.5689C15 32.4639 16.5474 34 18.4562 34H20.3723C21.0512 34 21.603 33.4562 21.6079 32.7822L21.6348 32.7733Z",
    fill: "#32324B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.8b04ef35fc35e1e4c084d53cd548b4c3.svg";
export { ForwardRef as ReactComponent };